// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiselect{height:180px!important}.vs--open .vs__search,.vs__search{font-size:20px}", ""]);
// Exports
module.exports = exports;
